import { render, staticRenderFns } from "./Lov.vue?vue&type=template&id=53838bde&"
import script from "./Lov.vue?vue&type=script&lang=ts&"
export * from "./Lov.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports